import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);

export default selector;

export const configSelector = createSelector(
  selector,
  (store) => {
    const response = get(store, 'response', {});
    let { dashboardTypeId } = response;
    if (dashboardTypeId === undefined) {
      dashboardTypeId = response.dashboardType.id;
    }
    return { ...response, dashboardTypeId };
  },
);
